import type { FaireProductEntity } from "../../entity_types/product";

export const p_cfmuq9vr5q: FaireProductEntity = {
  token: "p_cfmuq9vr5q",
  type: "product",
  name: "Tomato Leaf Candle",
  brandToken: "b_fyb6rnmnyf",
  brandName: "Putnam Design LLC",
  imageUrl:
    "https://cdn.faire.com/fastly/26fac5c39b1479860fa3056b52963e2492bdbee6d8f151a081cccbeb16a435f7.jpeg",
  galleryImageUrls: [],
  priceDollars: 20,
  description:
    "Single note scented candled hand-poured and crafted in Los Angeles exclusively by Putnam Design.\n\n• 9 oz of Soy wax\n• 40 hour burn time\n• Trim wick before each use",
  tags: [],
  msrpDollars: 40,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:08.549Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
